import { getGlobalData } from '@/lib/utils';
import Lang from 'lang.js/esm/lang';

const getTrans = () =>
	new Lang({
		...getGlobalData('language'),
		messages: getGlobalData('translations'),
	});

// Deprecated: 'trans' will be removed in future versions. Use 'getTrans()' instead.
const trans = getTrans();

/**
 * @typedef {Record<string, Primitive>} TranslationParams
 * @typedef {(params?: TranslationParams) => string} TranslationFunction
 */
/**
 * Returns an array of translation functions for the given keys.
 *
 * @param {readonly string[]} keys
 * @returns {TranslationFunction[]}
 */
const useTranslations = (keys) => keys.map((key) => (p) => getTrans().get(key, p));

export { trans, getTrans, useTranslations };
